import { render, staticRenderFns } from "./AddTerms.vue?vue&type=template&id=4a4a8818&"
import script from "./AddTerms.vue?vue&type=script&lang=js&"
export * from "./AddTerms.vue?vue&type=script&lang=js&"
import style0 from "./AddTerms.vue?vue&type=style&index=0&id=4a4a8818&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports